import { render, staticRenderFns } from "./PopupFoodDairySuccessSave.vue?vue&type=template&id=8180f376"
import script from "./PopupFoodDairySuccessSave.vue?vue&type=script&lang=js"
export * from "./PopupFoodDairySuccessSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports